import { gql } from '@apollo/client';
import { type DocumentNode } from 'graphql';

export const GET_PAGE_CMS_EDITOR_DATA: DocumentNode = gql`
  query pageCmsEditorData($pageId: Int!, $communityId: Int!) {
    pageCMS(id: $pageId) {
      id
      pageNavTitle
      isHidden
      isExclude
      bannerFile {
        id
        hash
        extension
        url
        name
      }
      translations {
        id
        communityId
        field
        iso
        objectId
        objectType
        value
      }
      panels {
        id
        settings {
          __typename
          ... on TextPanelSettings {
            type
            size
            text
            buttonConfig {
              display
              category
              text
              url
              externalUrl
              targetType
            }
          }
          ... on ImagePanelSettings {
            type
            size
            imageFile {
              id
              hash
              extension
              url
              name
            }
            imageWidth
            imageAltText
            imageRoundedCorners
            buttonConfig {
              display
              category
              text
              url
              externalUrl
              targetType
            }
          }
          ... on VideoPanelSettings {
            type
            size
            embed
            videoUrl
            videoEmbedCode
          }
          ... on IdeasPanelSettings {
            type
            size
            ideasDisplay: display
            ideasDefault: default
            timespan
          }
          ... on LeaderboardPanelSettings {
            type
            size
            leaderboardDisplay: display
            leaderboardDefault: default
          }
          ... on ChallengeCarouselPanelSettings {
            type
            size
            favourites
            hideDescription
            includeUserChallenges
          }
          ... on LinePanelSettings {
            type
            size
          }
          ... on ActivityPanelSettings {
            type
            size
          }
          ... on BlogCarouselPanelSettings {
            type
            size
          }
        }
      }
    }
    challenges(publicationStatus: PUBLISHED_AND_ARCHIVED, includeUserCreated: true) {
      id
      title
      archived
    }
    pages(communityId: $communityId, publicationStatus: PUBLISHED, order: ["order"]) {
      id
      title
      pageNavTitle
      type
      isHidden
    }
  }
`;
